import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { Box, type SxProps } from "@mui/material";
import type { FC, RefObject } from "react";
import type { ChannelName } from "../../channels/types";

export const DefaultContentEditable: FC<{
  focusEditor: () => void;
  scrollerProps?: { sx: SxProps };
  scrollerRef?: RefObject<HTMLDivElement | null>;
  channel: ChannelName;
  onRef: (x: HTMLDivElement) => void;
  disabled?: boolean;
  "data-testid"?: string;
}> = ({
  focusEditor,
  scrollerProps,
  scrollerRef,
  channel,
  onRef,
  disabled,
  "data-testid": testId,
}) => {
  return (
    <Box
      onClick={focusEditor}
      sx={{
        minHeight: "300px",
        resize: "vertical",
        height: "100%",
        alignItems: "stretch",
        ...scrollerProps?.sx,
      }}
      ref={(element: HTMLDivElement | null) => {
        if (scrollerRef) scrollerRef.current = element;
        if (element) onRef(element);
      }}
    >
      <ContentEditable
        className={`editor-content editor-main ${channel} ${disabled ? "read-only" : ""}`}
        data-testid={testId ?? "editor-content"}
      />
    </Box>
  );
};
